import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CDialog, P } from '@appcues/component-library';

import { selectAccountMeta } from 'reducers/account/meta';

import { removeAccountUserAndFlushUsers } from 'actions/accountManagement';

const ConfirmRemoveUseFromTeamModal = ({
  selectedUser,
  company,
  onRemove,
  onClose,
}) => {
  const handleRemove = () => {
    onRemove(selectedUser);
    onClose();
  };

  return (
    <CDialog
      title="Remove from Team?"
      primaryActionText="Remove"
      onPrimaryAction={handleRemove}
      secondaryActionText="Cancel"
      onSecondaryAction={onClose}
      size="small"
    >
      <P lineHeight="24px">
        Are you sure you want to remove
        <br />
        <strong>{selectedUser.fullname || selectedUser.email}</strong> from the{' '}
        {company} team?
      </P>
    </CDialog>
  );
};

const mapStateToProps = state => {
  const { id, name } = selectAccountMeta(state);
  return {
    company: name || id,
  };
};

const mapDispatchToProps = {
  onRemove: selectedUser =>
    removeAccountUserAndFlushUsers({
      userToRemove: selectedUser,
    }),
};

ConfirmRemoveUseFromTeamModal.propTypes = {
  selectedUser: PropTypes.any,
  company: PropTypes.string,
  onRemove: PropTypes.func,
  onClose: PropTypes.func,
};

const ConnectedConfirmRemoveUseFromTeamModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmRemoveUseFromTeamModal);

export default ConnectedConfirmRemoveUseFromTeamModal;
